export default "__VITE_ASSET__CIVAzDIL__"